import clsx from 'clsx';
import React, { useEffect, useState } from 'react';
import { InView } from 'react-intersection-observer';
import { usePDPData } from '~/features/product-details/context';
import styles from './YotpoReviewsSection.module.scss';

export const YotpoReviewsSection: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({
    className,
    ...rest
}) => {
    const { product, yotpoIdentifier } = usePDPData();
    const [isInView, setIsInView] = useState(false);

    // Reset Yotpo review section on product change.
    useEffect(() => {
        // eslint-disable-next-line react-hooks/set-state-in-effect
        setIsInView(false);
    }, [product?.id]);

    // Once section is in view, we will load the Yotpo widgets.
    useEffect(() => {
        if (isInView) window.yotpoWidgetsContainer?.initWidgets?.();
    }, [isInView]);

    if (!product?.id || !product?.name) return null;

    return (
        <InView
            className={styles.yotpoReviewsSection}
            id={yotpoIdentifier}
            // This will make this element focusable to allow us to switch focus when being anchored from `yotpoIdentifier`.
            tabIndex={-1}
            rootMargin="300px 0px"
            threshold={0}
            as="div"
            onChange={(inView) => {
                if (inView) setIsInView(true);
            }}
        >
            {isInView && (
                <div
                    className={clsx('yotpo-widget-instance', className)}
                    {...rest}
                    data-yotpo-instance-id="647101"
                    data-yotpo-product-id={product.id}
                    data-yotpo-name={product.name}
                />
            )}
        </InView>
    );
};
